import { render, staticRenderFns } from "./EChartBasic.vue?vue&type=template&id=2ffe32f4&"
import script from "./EChartBasic.vue?vue&type=script&lang=js&"
export * from "./EChartBasic.vue?vue&type=script&lang=js&"
import style0 from "./EChartBasic.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports